let defaultCoverageAvatelForm = {
    direccion: '',
    cp: '',
    localidad: '',
    provincia: '',
    lat: '',
    lng: '',
}

export default defaultCoverageAvatelForm